import { TranslateResources } from './translateCodes';

const translation: Partial<TranslateResources> = {
};

export const vi = {
    translation
};